import React from "react";
import { ticketPhases } from "components/dashboard/AgentInbox/enum";
import { useSelector } from "react-redux";
import { ticketsFilterBuilder } from "../../constants";
import TicketFilterSelector from "../../TicketFilterSelector/TicketFilterSelector";
import { ticketSourcesLabel } from "./enum";
import { truncateString } from "utils/helper";
import "./TicketPhaseSelector.scss";

const TicketPhaseSelector = ({
    ticketPhaseCounts,
    allPhaseCounts,
    fetchingCount,
    handleTicketPhaseSelect,
    selectedTicketPhase,
    handleTicketSourceSelect,
    ticketSource,
}) => {
    const { userId } = useSelector((state) => state.auth?.user);
    const { incomingTickets } = useSelector((state) => state?.incomingTickets);

    const orderedPhases = [
        ticketPhases.ALL,
        ticketPhases.ISSUE_DISCOVERY,
        ticketPhases.PROBLEM_CONFIRMATION,
        ticketPhases.SOLUTION_DELIVERY,
    ];

    const filterByTicketStatus = (ticket) =>
        ticket.ticketStatus === true && ticket.isNew === true;

    return (
        <div>
            <div className='d-flex'>
                {orderedPhases.map((ticketPhase, index) => {
                    const filterBlock = ticketsFilterBuilder[ticketPhase];
                    if (!filterBlock) return null;

                    const isActive = selectedTicketPhase === ticketPhase;
                    const sourceCounts =
                        ticketPhase === ticketPhases.ALL
                            ? allPhaseCounts
                            : ticketPhaseCounts;
                    const countValue =
                        sourceCounts?.[filterBlock?.["countKey"]];
                    const baseKey = `ticket-phase-${ticketPhase}`;

                    if (ticketPhase === ticketPhases.ALL) {
                        const hasNew =
                            incomingTickets?.some(filterByTicketStatus) || false;
                        return (
                            <TicketFilterSelector
                                key={baseKey}
                                label={
                                    isActive
                                        ? filterBlock?.title
                                        : truncateString(filterBlock?.title, 12)
                                }
                                countValue={countValue}
                                isActive={isActive}
                                onClick={() =>
                                    handleTicketPhaseSelect(ticketPhase)
                                }
                                hasNew={hasNew}
                                fetchingCount={fetchingCount}
                                activeStyles={filterBlock?.activeStyles}
                            />
                        );
                    }

                    const filterByTicketPhase = (ticket) =>
                        ticket.ticketPhase === ticketPhase;

                    const onlyNewTickets =
                        incomingTickets
                            ?.filter(filterByTicketPhase)
                            ?.filter(filterByTicketStatus) || [];

                    if (ticketPhase === ticketPhases.ISSUE_DISCOVERY) {
                        const filterByMessageTag = (ticket) =>
                            ticket.issueDiscovered === true;
                        const hasNew =
                            onlyNewTickets.filter(filterByMessageTag).length >
                            0;

                        return (
                            <TicketFilterSelector
                                key={baseKey}
                                label={
                                    isActive
                                        ? ticketSourcesLabel[ticketSource]
                                              ?.label || filterBlock?.title
                                        : truncateString(
                                              ticketSourcesLabel[ticketSource]
                                                  ?.label ||
                                                  filterBlock?.title,
                                              9
                                          )
                                }
                                countValue={countValue}
                                isActive={isActive}
                                onClick={() =>
                                    handleTicketPhaseSelect(ticketPhase)
                                }
                                hasNew={hasNew}
                                fetchingCount={fetchingCount}
                                activeStyles={filterBlock?.activeStyles}
                                handleDropdownAction={
                                    handleTicketSourceSelect
                                }
                                showFilterSelectorDropdown={isActive}
                                ticketSource={ticketSource}
                            />
                        );
                    }

                    const filterByTicketInfoValue = (ticket) =>
                        ticket?.assigned === true &&
                        ticket?.assignedTeamMemberId === userId;
                    const hasNew =
                        onlyNewTickets.filter(filterByTicketInfoValue).length >
                        0;

                    return (
                        <TicketFilterSelector
                            key={baseKey}
                            label={
                                isActive
                                    ? filterBlock?.title
                                    : truncateString(
                                          filterBlock?.title,
                                          index === 0 ? 10 : 11
                                      )
                            }
                            countValue={countValue}
                            isActive={isActive}
                            onClick={() =>
                                handleTicketPhaseSelect(ticketPhase)
                            }
                            hasNew={hasNew}
                            fetchingCount={fetchingCount}
                            activeStyles={filterBlock?.activeStyles}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default TicketPhaseSelector;
